import { connect } from "react-redux";
import { compose } from "redux";
import { selectIsDevicesLoaded } from "../../redux/assets/assetsSelectors";
import { createStructuredSelector } from "reselect";
import { selectIsGeofencesLoaded } from "../../redux/geofence/geofenceSelectors";

import WithSpinner from "../../components/withSpinner/withSpinner.component";
import FleetView from "./views/FleetView";

const mapStateToProps = createStructuredSelector({
  isLoading: (state) => !selectIsDevicesLoaded(state) || !selectIsGeofencesLoaded(state),
});

const FleetContainer = compose(
  connect(mapStateToProps),
  WithSpinner
)(FleetView);

export default FleetContainer; 